<mat-list-item>
  <mat-checkbox aria-label="Completed" [indeterminate]="isIndeterminate()" [checked]="isComplete()" (change)="toggleCompleted($event)"></mat-checkbox>
  <div>
      <span matLine>{{task.title}}</span>
      <span matLine *ngIf="task.due && !task.completed">Due: {{task.due|date}}</span>
      <span matLine *ngIf="task.completed">Done: {{task.completed|date}}</span>
  </div>
  <span class="spacer"></span>
  <button mat-icon-button class="icon-btn-sm" *ngIf="!task.deleted" aria-label="Delete" (click)="delete()">
    <mat-icon *ngIf="!task.deleted">delete</mat-icon>
  </button>
  <button mat-icon-button class="icon-btn-sm" *ngIf="task.deleted" aria-label="Restore" (click)="undelete()">
    <mat-icon *ngIf="task.deleted">delete_restore</mat-icon>
  </button>
</mat-list-item>
